import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => settings.is_mobile_number_field,
);
